export enum VoucherRedeemStatus {
	UNKNOWN = 0,
	PENDING = 1,
	REDEEMED = 2,
	EXPIRED = 3,
}
